import { Box, StepIconProps, StepLabel, styled } from "@mui/material";
import StepConnector from "@mui/material/StepConnector";
import Step from "@mui/material/Step";
import { RightIcon } from "@icons/RightIcon";
import { LeftIcon } from "@icons/LefttIcon";
import { ArrowStepIconRoot, StepIconRoot } from "./Steps.styles";

export function ArrowRight(props: StepIconProps) {
    const { className } = props;

    return (
        <ArrowStepIconRoot className={className}>
            <RightIcon />
        </ArrowStepIconRoot>
    );
}

export function ArrowLeft(props: StepIconProps) {
    const { className } = props;

    return (
        <ArrowStepIconRoot className={className}>
            <LeftIcon />
        </ArrowStepIconRoot>
    );
}

export function WinStep(props: StepIconProps) {
    const { active, className } = props;

    return (
        <StepIconRoot
            className={className}
            style={{
                backgroundColor: "#008300",
                ...(active && {
                    outline: "1px solid #008300",
                    outlineOffset: "1px",
                }),
            }}
        >
            S
        </StepIconRoot>
    );
}

export function LossStep(props: StepIconProps) {
    const { active, className } = props;

    return (
        <StepIconRoot
            className={className}
            style={{
                backgroundColor: "#D22F2F",
                ...(active && {
                    outline: "1px solid #D22F2F",
                    outlineOffset: "1px",
                }),
            }}
        >
            N
        </StepIconRoot>
    );
}

export function DrawStep(props: StepIconProps) {
    const { active, className } = props;

    return (
        <StepIconRoot
            className={className}
            style={{
                backgroundColor: "#dcdcdc",
                ...(active && {
                    outline: "1px solid #dcdcdc",
                    outlineOffset: "1px",
                }),
            }}
        >
            U
        </StepIconRoot>
    );
}
